import Vue from 'vue'
import App from './App.vue'
// Vuex Store
import store from './store/store'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format'
import VueMask from 'v-mask'
import Vuelidate from 'vuelidate'
import VueGtag from 'vue-gtag'
import VueDebounce from 'vue-debounce'
import Rollbar from 'vue-rollbar'
import VueTour from 'vue-tour'
import VueClipboard from 'vue-clipboard2'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
Vue.use(VueMask)
Vue.use(Vuelidate)
Vue.use(VueFilterDateFormat)
Vue.use(Vuesax)
Vue.use(VueDebounce)
Vue.use(VueClipboard)

// Vue rollbar
Vue.use(Rollbar, {
  accessToken                : process.env.VUE_APP_ROLLBAR_TOKEN,
  captureUncaught            : true,
  captureUnhandledRejections : true,
  enabled                    : true,
  source_map_enabled         : false,
  environment                : process.env.VUE_APP_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0'
      }
    },
    user: {
      id:        store.state.sessionUser.id,
      email:     store.state.sessionUser.email,
      firstName: store.state.sessionUser.firstName,
      lastName:  store.state.sessionUser.lastName
    }
  }
})


let ignoredKeywords = [];

try {
  const raw = process.env.VUE_APP_IGNORED_ERROR_KEYWORDS
  ignoredKeywords = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : []
} catch (err) {
  console.warn(
    '[ErrorHandler] Invalid VUE_APP_IGNORED_ERROR_KEYWORDS in .env, using empty list.',
    err
  );
  ignoredKeywords = []
}

Vue.config.errorHandler = err => {
  const message = err.message;
  const shouldIgnore = ignoredKeywords.some(keyword =>
    message.includes(keyword)
  );

  if (shouldIgnore) {
    console.warn('[Ignored Error]', message)
    return
  }

  const shortStack =
    err && typeof err.stack === 'string'
      ? err.stack.split('\n').slice(0, 5).join('\n')
      : 'No stack trace';

  Vue.rollbar.error(message, {
    custom: {
      shortStack
    }
  })
}


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'
// Theme Configurations
import '../themeConfig.js'
// Globally Registered Components
import './globalComponents.js'
// Styles: SCSS
import './assets/scss/main.scss'
// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Google Analytics
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID }
}, router)


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

// router on error to handle app updates
router.onError(error => {
  if (/loading chunk ([^\s]+) failed/i.test(error.message)) {
    window.location.reload()
  }
})

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
